export const FLEX_COLUMN_SX = {
  display: "flex" as React.CSSProperties["display"],
  flexDirection: "column" as React.CSSProperties["flexDirection"],
};
export const FLEX_ROW_SX = {
  display: "flex" as React.CSSProperties["display"],
  flexDirection: "row" as React.CSSProperties["flexDirection"],
};
